// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"Search_searchContainer__29xXS","resultPanel":"Search_resultPanel__3uhKz"};